import { render } from "./UserMenu.html?vue&type=template&id=f163e83e&scoped=true&ts=true&external"
import script from "./UserMenu.ts?vue&type=script&lang=ts&external"
export * from "./UserMenu.ts?vue&type=script&lang=ts&external"

import "./UserMenu.scss?vue&type=style&index=0&id=f163e83e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f163e83e"]])

export default __exports__